import './BuyerList.scss';
import Component from './BuyerList.js';
export default Component;
